import React from "react";
import { motion } from "framer-motion";
import { Eyebrow } from "../components/Primitives";
import Logo from "../components/Logo";

export default function DeadEnd() {
    return (
        <div className="flex-1 flex flex-col bg-cream" data-testid="dead-end-screen">
            <div className="px-6 pt-10 pb-6 flex justify-start">
                <Logo size={56} />
            </div>

            <motion.div
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                className="flex-1 flex flex-col justify-center px-7"
            >
                <Eyebrow className="mb-5">A small note</Eyebrow>

                <h1 className="font-display text-4xl sm:text-5xl leading-[1.1] text-burgundy tracking-tight">
                    <span className="italic">Thank you</span> for sharing.
                </h1>

                <p className="mt-6 font-display italic text-xl text-ink leading-snug">
                    Based on your responses, Ever After isn't the right fit for you right now.
                </p>

                <div className="mt-6 editorial-rule" />

                <p className="mt-6 text-base text-ink-muted leading-relaxed font-light">
                    We build Ever After for a specific kind of partnership — one rooted in honesty, accountability, and long-term care. Our community standards keep that intact for everyone inside it.
                </p>

                <p className="mt-4 text-base text-ink-muted leading-relaxed font-light">
                    We wish you the very best on your journey, wherever it leads.
                </p>

                <div className="mt-10 flex items-center gap-3 text-gold">
                    <span className="h-px flex-1 bg-burgundy/15" />
                    <span className="font-display italic text-sm tracking-wide">·</span>
                    <span className="h-px flex-1 bg-burgundy/15" />
                </div>
            </motion.div>

            <div className="px-6 pb-10 text-center">
                <p className="text-[10px] tracking-[0.32em] uppercase text-ink-light">
                    Ever After · A community by invitation
                </p>
            </div>
        </div>
    );
}
